import AddComposerTag from './AddComposerTag';

const composerTag = {
  id: 'composer',
  AddTag: AddComposerTag
};

export default composerTag;
